import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss'],


})
export class HomeComponent implements OnInit {


    userData$: Observable<any> | undefined;
    isAuthenticated$: Observable<boolean> | undefined;



    constructor(public oidcSecurityService: OidcSecurityService, private translate: TranslateService) {
        var currentLanguage = navigator.language;

        switch (currentLanguage) {
            case 'pt':
                currentLanguage = "pt-BR"
                break;
            case 'pt-BR':
                currentLanguage = "pt-BR"
                break;
            case 'es':
                currentLanguage = "es"
                break;
            case 'es-419':
                currentLanguage = "es"
                break;
            default:
                currentLanguage = "en"
                break;

        }

        this.translate.setDefaultLang(currentLanguage);
        this.translate.use(currentLanguage);
    }

    ngOnInit() {
        this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;
        this.userData$ = this.oidcSecurityService.userData$;
        console.log(this.userData$);
    }


}
